import { KyInstance } from 'ky';

import { IReqOrderById } from '@/types/fulfill/statusOrders/orderById.interface';
import { IReqOrders } from '@/types/fulfill/statusOrders/orders.interface';
import { handleRequest } from '@/utils/httpUtils';

import {
  CancelOrder,
  DownloadOrderLabel,
  DownloadOrders,
  OrderById,
  OrderByIdResponse,
  Orders,
  OrdersResponse,
} from './types';

export interface IReqStatusOrders {
  orders: Orders;
  cancelOrder: CancelOrder;
  orderById: OrderById;
  downloadOrders: DownloadOrders;
  downloadOrderLabel: DownloadOrderLabel;
}

export function reqStatusOrders(http: KyInstance): IReqStatusOrders {
  const route = 'api/v1';
  return {
    orders: ({ deliveryType, fulfillmentStatus, ...ars }: IReqOrders) => {
      const queryParams = buildRouteParamsFF(ars, [deliveryType!, fulfillmentStatus!]);
      return handleRequest<OrdersResponse>(http, 'get', `${route}/orders${queryParams}`);
    },
    cancelOrder: (ars) => {
      return handleRequest(http, 'patch', `${route}/orders/${ars.orderId}`, {
        json: {
          fulfillmentStatus: ars.fulfillmentStatus,
        },
      });
    },
    orderById: ({ trackingId }: IReqOrderById) =>
      handleRequest<OrderByIdResponse>(http, 'get', `${route}/orders/${trackingId}`),
    downloadOrders: ({ filters, report_type, ...ars }) => {
      const queryParams = buildRouteParamsFF(ars, [filters]);
      return handleRequest(
        http,
        'get',
        `${route}/downloads/orders/csv${queryParams}&report_type=${report_type}`,
      );
    },
    downloadOrderLabel: ({ orderId }) =>
      handleRequest(http, 'get', `${route}/orders/${orderId}/pdf`),
  };
}

const buildRouteParamsFF = (
  ars: Record<string, string | number | boolean | undefined>,
  filters?: string[],
) => {
  let route = '?';
  Object.entries(ars).forEach(([key, value]) => {
    const validation = value !== undefined && value !== null && value !== '';
    if (validation) {
      route += route.length > 1 ? `&${key}=${value}` : `${key}=${value}`;
    }
  });
  if (filters && filters.length > 0) {
    filters.forEach((filter) => {
      if (filter.length > 0) {
        route += route.length > 1 ? `&${filter}` : `${filter}`;
      }
    });
  }
  return route;
};
